import React from 'react';
import PropTypes from 'prop-types';

import {
  Direction,
  Column,
  Margin,
  Heading,
  TextSmall,
  Card,
  ButtonPrimary,
  ButtonSecondary,
  ButtonPill,
  ButtonText
} from '@scotia/canvas-react';
import { Divider } from '../Divider';
import { Alignment } from '../Alignment';
import { ReverseDirection } from '../ReverseDirection';

const BaseInfoContent = ({
  icon,
  title,
  children,
  buttons,
  buddyTip,
  buttonRenderer
}) => {
  const columns = React.Children.map(
    buttonRenderer(buttons),
    button =>
      React.Children.count(buttons) === 1 ? (
        <Column lg={4} md={8} xs={12}>
          {button}
        </Column>
      ) : (
        <Column lg={2} md={4} xs={12}>
          <Margin xs={12} sm={12} side="bottom">
            {button}
          </Margin>
        </Column>
      )
  );
  return (
    <React.Fragment>
      <Direction key={0}>
        <Column lgOffset={4} lg={4} mdOffset={2} md={8} xs={12}>
          <Margin lg={36} md={36} sm={36} xs={36} side="top">
            <Alignment lg={'center'} md={'center'} sm={'center'} xs={'center'}>
              <div style={{ lineHeight: 0 }}>{icon}</div>
            </Alignment>
          </Margin>
          <Margin lg={24} md={24} sm={24} xs={24} side="top">
            <Alignment lg={'center'} md={'center'} sm={'center'} xs={'center'}>
              <Heading>{title}</Heading>
            </Alignment>
          </Margin>
          <Margin lg={24} md={24} sm={24} xs={24} side="both">
            <div style={{ lineHeight: 0 }}>
              <Divider />
            </div>
          </Margin>
          <Margin lg={36} md={36} sm={36} xs={36} side="bottom">
            <Alignment lg={'center'} md={'center'} sm={'center'} xs={'center'}>
              <TextSmall>{children}</TextSmall>
            </Alignment>
          </Margin>
          {buddyTip && (
            <Margin lg={36} md={36} sm={36} xs={36} side="bottom">
              <Alignment
                lg={'center'}
                md={'center'}
                sm={'center'}
                xs={'center'}
              >
                {buddyTip}
              </Alignment>
            </Margin>
          )}
        </Column>
      </Direction>
      <ReverseDirection key={1}>{columns}</ReverseDirection>
    </React.Fragment>
  );
};

const buttonCustomStyle = { width: '100%', whiteSpace: 'nowrap' };

const buttonMapper = (button, Primary, Secondary) =>
  button.type === InfoContentPrimaryButton ? (
    <Primary {...button.props} style={buttonCustomStyle} />
  ) : (
    <Secondary {...button.props} style={buttonCustomStyle} />
  );

export const InfoContent = props => (
  <BaseInfoContent
    {...props}
    buttonRenderer={buttons =>
      React.Children.map(buttons, button =>
        buttonMapper(button, ButtonPrimary, ButtonSecondary)
      )
    }
  />
);
export const CardInfoContent = props => (
  <Card>
    <BaseInfoContent
      {...props}
      buttonRenderer={buttons =>
        React.Children.map(buttons, button =>
          buttonMapper(button, ButtonPill, ButtonText)
        )
      }
    />
  </Card>
);

export const InfoContentPrimaryButton = () => null;
export const InfoContentSecondaryButton = () => null;
